export default __webpack_public_path__ + "locales/uk-UA/Webhooks.json?hash=280449ed06e0f66f337631406eef3fa9";